import React, { useRef, useEffect } from "react";
import _ from "lodash";
import cx from "classnames";
import { connect } from "react-redux";
import { AnimatePresence } from "framer-motion/dist/framer-motion";

import ChooseAsker from "./screens/ChooseAsker";
import QuestionSubmit from "./screens/QuestionSubmit";
import Question from "./screens/Question";
import Over from "./screens/Over";
import BeforeAnswerSubmit from "../LT/components/BeforeAnswerSubmit";
import AfterAnswerSubmit from "../LT/components/AfterAnswerSubmit";
import * as sbsAction from "redux/sbs/action";

const LTS = (props) => {
  const sbsReducer = _.get(props, "sbsReducer");
  const set_lt_countdown = _.get(props, "set_lt_countdown");
  const countdown = _.get(sbsReducer, "lt_countdown");
  const lt_question = _.get(sbsReducer, "lt_question");
  const has_answered = _.get(sbsReducer, "has_answered");
  const reset_lts_state = _.get(props, "reset_lts_state");
  const set_lt_question = _.get(props, "set_lt_question");
  const set_answers = _.get(props, "set_answers");
  const set_correct_answer = _.get(props, "set_correct_answer");
  const set_question = _.get(props, "set_question");
  const set_has_answered = _.get(props, "set_has_answered");
  const gameReducer = _.get(props, "gameReducer");
  const mobile_app = _.get(gameReducer, "mobile_app");
  const currentUser = _.get(gameReducer, "currentUser");
  const roomObj = _.get(gameReducer, "roomObj");
  const users = _.get(roomObj, "users");
  const game_state = _.get(roomObj, "game_state");
  const questionObj = _.get(game_state, "question");
  const status = _.get(game_state, "status");
  const player = _.get(game_state, "player");
  const asker_id = _.get(game_state, "asker");
  const answers_array = _.get(questionObj, "answers");
  const correct_answer = _.get(questionObj, "correct_answer");
  const current_round = _.get(game_state, "current_round");

  const asker = users?.find((user) => user.player_id === asker_id);
  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser.userId
  );
  const isAsker = currentPlayer?.player_id === asker_id;
  const playerInfo = player?.find(
    (value) => value.player_id === currentPlayer?.player_id
  );
  const current_player_answer_time = playerInfo?.answer_time;
  const current_player_answer = playerInfo?.answer;
  const firstUpdate = useRef(true);

  const chooseasker_params = _.get(
    props,
    "paramsReducer.gameObj.1_chooseasker"
  );
  const question_submit_params = _.get(
    props,
    "paramsReducer.gameObj.2_question_submit"
  );
  const question_params = _.get(props, "paramsReducer.gameObj.3_question");
  const over_params = _.get(props, "paramsReducer.gameObj.4_over");

  const sound_in = _.get(chooseasker_params, "sound_in");
  const sound_out = _.get(chooseasker_params, "sound_out");
  const player_joins = _.get(chooseasker_params, "player_joins");
  const player_left = _.get(chooseasker_params, "player_left");
  const select_sound = _.get(question_submit_params, "select");
  const choose_answer = _.get(question_submit_params, "choose_answer");
  const transition_sound = _.get(question_params, "transition");

  useEffect(() => {
    const audioElement = document.createElement("audio");
    audioElement.id = "player";
    document.body.appendChild(audioElement);
  }, []);

  const playAudio = (url) => {
    if (mobile_app) {
      const message = {
        action: "play-audio",
        audio: url
      };
      window.parent.postMessage(message, "*");
    } else {
      var player = document.getElementById("player");
      if (player) {
        player.src = url;
        player.play();
      }
      return;
    }
  };

  useEffect(() => {
    if (status === "ChooseAsker") {
      playAudio(sound_in);
    } else if (status === "QuestionSubmit") {
      playAudio(sound_in);
    } else if (status === "Question") {
      playAudio(sound_in);
    } else if (status === "Over") {
      playAudio(sound_in);
    }
  }, [status]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    set_has_answered(false);
  }, [current_round]);

  return (
    <div className="smallbites heightAuto">
      <div
        className={cx("bingo-content-wrapper", {
          "playing-overflow-scroll": status === "Playing"
        })}
      >
        <AnimatePresence exitBeforeEnter>
          {status === "ChooseAsker" && (
            <ChooseAsker
              // key={31}
              users={users}
              mobile_app={mobile_app}
              chooseasker_params={chooseasker_params}
            />
          )}
          {status === "QuestionSubmit" && (
            <QuestionSubmit
              // key={32}
              users={users}
              asker={asker}
              isAsker={isAsker}
              roomId={roomObj.id}
              playAudio={playAudio}
              sbsReducer={sbsReducer}
              mobile_app={mobile_app}
              set_answers={set_answers}
              select_sound={select_sound}
              set_question={set_question}
              choose_answer={choose_answer}
              reset_lts_state={reset_lts_state}
              set_correct_answer={set_correct_answer}
              question_submit_params={question_submit_params}
            />
          )}
          {status === "Question" &&
            (isAsker ? (
              <Question
                // key={33}
                users={users}
                player={player}
                roomId={roomObj.id}
                playAudio={playAudio}
                mobile_app={mobile_app}
                questionObj={questionObj}
                select_sound={select_sound}
                question_params={question_params}
              />
            ) : !has_answered ? (
              <BeforeAnswerSubmit
                lts
                // key={34}
                roomObj={roomObj}
                sound_in={sound_in}
                playAudio={playAudio}
                countdown={countdown}
                mobile_app={mobile_app}
                lt_question={lt_question}
                questionObj={questionObj}
                transition={transition_sound}
                currentPlayer={currentPlayer}
                set_lt_question={set_lt_question}
                question_params={question_params}
                set_has_answered={set_has_answered}
                set_lt_countdown={set_lt_countdown}
              />
            ) : (
              <AfterAnswerSubmit
                lts
                // key={35}
                sound_in={sound_in}
                playAudio={playAudio}
                mobile_app={mobile_app}
                questionObj={questionObj}
                answers_array={answers_array}
                question_params={question_params}
                current_player_answer={current_player_answer}
                current_player_answer_time={current_player_answer_time}
              />
            ))}
          {status === "Over" && (
            <Over
              // key={36}
              player={player}
              isAsker={isAsker}
              roomId={roomObj.id}
              sound_in={sound_in}
              playAudio={playAudio}
              playerInfo={playerInfo}
              mobile_app={mobile_app}
              questionObj={questionObj}
              over_params={over_params}
              answers_array={answers_array}
              correct_answer={correct_answer}
              set_has_answered={set_has_answered}
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sbsReducer: state.sbsReducer,
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => ({
  reset_lts_state: () => dispatch(sbsAction.reset_lts_state()),
  set_answers: (data) => dispatch(sbsAction.set_answers(data)),
  set_question: (data) => dispatch(sbsAction.set_question(data)),
  set_lt_question: (data) => dispatch(sbsAction.set_lt_question(data)),
  set_lt_countdown: (data) => dispatch(sbsAction.set_lt_countdown(data)),
  set_has_answered: (data) => dispatch(sbsAction.set_has_answered(data)),
  set_correct_answer: (data) => dispatch(sbsAction.set_correct_answer(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(LTS);
